<template>
  <div class="card category__first-trip bg-white shadow-md flex flex-wrap relative m-0 rounded-lg overflow-hidden">
    <div class="w-12/12 md:w-6/12 px-0 category__first-trip__image relative">
      <div class="absolute bottom-[40px] left-0 hidden md:block">
        <FavouriteIcon
          :id="trip?.id"
          class="!rounded-tr-lg !rounded-br-none !z-[5]"
        />
      </div>
      <div class="absolute right-[40px] block md:hidden">
        <FavouriteIcon
          :id="trip?.id"
          class="!rounded-bl-lg !rounded-br-none !z-[5]"
        />
      </div>
      <div class="aspect-16/9 md:aspect-auto max-h-64 md:max-h-none h-100">
        <ResponsiveImage
          class="size-full top-0 left-0 md:rounded-bl-xl"
          :image="trip?.main_picture_cloudinary"
          :alt="trip?.title"
          position="absolute"
        />
      </div>
    </div>
    <div class="w-12/12 md:w-6/12">
      <div class="relative text-white mt-6 md:mt-6 left-0 flex items-start overflow-hidden">
        <div
          v-if="trip?.price_min"
          class="inline-flex items-center h-7 py-1 pl-4 pr-3 text-nowrap relative bg-brick-red"
        >
          <fa
            :icon="trip?.flight_trip ? 'plane' : 'bus'"
          />
          <span
            v-if="days"
            class="mx-2 text-base font-bold primary-font"
            data-i18n="daysText"
          >
            {{ $t('daysText', { n: days(trip) }) }}
          </span>

          <i-tag-end
            :font-controlled="false"
            class="left-full top-0 -mt-[0.5px] h-[calc(100%+1px)] absolute text-brick-red -ml-[1px] "
          />
        </div>
      </div>
      <div class="px-4 py-4 sm:px-8 sm:py-6">
        <div class="text-2xl font-bold primary-font mb-2">
          {{ trip?.title }} {{ ' - ' }}<span class="font-bold primary-font text-2xl">
            {{ trip.subtitle }}
          </span>
        </div>
        <p class="font-secondary font-normal text-base line-clamp-[8] ">
          {{ trip?.short_preamble.trim() }}
        </p>
        <div class="primary-font category__first-trip__meta font-bold !text-2xl">
          <span class="mr-2">
            {{ $t('daysText', { n: days(trip) }) }}
          </span>
          <template v-if="trip?.price_min">
            <span class="mr-2">
              {{ $t('shortFromPrice') }}
            </span>
            <span
              v-if="isDiscounted"
              class="mr-2 strikethrough"
            >{{ $n(trip?.price_min_without_discount) }}</span>
            <span class="text-brick-red">
              {{ $n(trip?.price_min) }}
            </span>
          </template>
        </div>
        <div class="flex justify-end">
          <NuxtLink
            class="btn mt-4 btn-brick-red normal-case py-2 px-5 flex items-center"
            :to="trip?.url"
          >
            {{ $t('readMore') }}
            <fa
              class="pl-1"
              icon="arrow-right"
            />
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import daysMixin from '@layers/web/mixins/days.mixin'

export default defineNuxtComponent({
  mixins: [daysMixin],

  props: {
    trip: {
      type: Object,
      default: null,
    },
  },

  computed: {
    isDiscounted () {
      if (!this.trip?.price_min_without_discount || !this.trip?.price_min) {
        return false
      }
      return this.trip?.price_min_without_discount > this.trip?.price_min
    },
  },
})
</script>

<style lang="scss">
/*! purgecss start ignore */
.category__first-trip {
  h4 {
    letter-spacing: 0.5px;
    line-height: 1.2em;
  }
  h4.te, &__meta.te {
    @media (min-width: 1400px) {
      font-size: 1.2rem;
    }
    @media (max-width: 1400px) {
      font-size: 1.1rem;
    }
    @media (max-width: 920px) {
      font-size: 1rem;
    }
  }
  &__meta {
    font-size: 1.2rem;
    span {
      min-height: 30px;
      line-height: 30px;
      display: inline-block;
      white-space: nowrap;

      &.small {
        transform: translateY(0px);
      }
      &.larger {
        font-size:1.25em;
      }
    }
  }
}
/*! purgecss end ignore */
</style>
